// src/components/AvisoCustoNaoRecorrente.jsx
// Aviso exibido junto ao campo "custo não recorrente". Esse valor é SOMADO ao EBITDA do período para formar o EBITDA
// ajustado, que é a base do status de saúde, da alavancagem e do valuation. Se ele é uma fatia grande dos custos, o
// diagnóstico pode parecer melhor do que a operação realmente é (ex.: receita = custos, EBITDA do período zero, mas
// "saudável" por causa do ajuste). O aviso só aparece quando o ajuste passa de 50% dos custos (ou excede o total).
import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Converte "R$ 1.234,56" / "1.234,56" / "1234,5" em número (padrão brasileiro: ponto = milhar, vírgula = decimal).
function paraNumero(valor) {
  if (typeof valor === 'number') return valor;
  const limpo = String(valor || '').replace(/[^\d,]/g, '').replace(',', '.');
  const n = parseFloat(limpo);
  return Number.isFinite(n) ? n : 0;
}

export const LIMITE_AJUSTE_RELEVANTE = 0.5;

export default function AvisoCustoNaoRecorrente({ custos, naoRecorrente, className = '' }) {
  const totalCustos = paraNumero(custos);
  const ajuste = paraNumero(naoRecorrente);
  if (!(totalCustos > 0) || !(ajuste > 0)) return null;
  const fracao = ajuste / totalCustos;
  if (fracao <= LIMITE_AJUSTE_RELEVANTE) return null;

  const excede = fracao > 1;
  const pct = Math.round(fracao * 100);
  return (
    <div
      role="alert"
      className={`flex items-start gap-2 rounded-xl border border-amber-400/30 bg-amber-950/30 px-3 py-2.5 ${className}`}
    >
      <AlertTriangle size={14} className="mt-0.5 shrink-0 text-amber-300" />
      <p className="text-[11px] leading-relaxed text-amber-100">
        {excede
          ? 'O custo não recorrente é maior que os custos totais informados. Confira os valores.'
          : `Este custo não recorrente é ${pct}% dos custos totais. Ele é somado ao EBITDA e pode fazer a empresa parecer mais saudável do que está. Use apenas para gastos realmente pontuais.`}
      </p>
    </div>
  );
}
